import { Redirect, Route } from 'react-router-dom';
import { getDefaultPortalPath, resolveReturnTarget } from 'utils/return-url';

import ExternalRedirect from 'views/components/external-redirect';
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { getMeItem } from 'modules/me/selectors';
import { isAuthLoggedIn } from 'modules/auth/selectors';
import { useSelector } from 'react-redux';

const PublicRoute = ({ render, ...rest }) => {
  const isLoggedIn = useSelector(isAuthLoggedIn);
  const me = useSelector(getMeItem);

  const authenticatedRedirect = (location) => {
    const target = resolveReturnTarget(
      location.search,
      getDefaultPortalPath(me)
    );

    if (target.external) {
      return <ExternalRedirect url={target.url} />;
    }

    return <Redirect to={{ ...target.location, state: { from: location } }} />;
  };

  return (
    <Route
      {...rest}
      render={(otherProps) =>
        isLoggedIn === false
          ? render(otherProps)
          : authenticatedRedirect(otherProps.location)
      }
    />
  );
};

export default PublicRoute;
